RegistrationEmailSuccessCtrl = ($scope, $filter, $translate, $location, flash, RegistrationService, AuthService, TermService) ->
  return $location.path('/') if AuthService.isSignedIn()

  $scope.email = RegistrationService.getTokenFormEmail()

RegistrationEmailSuccessCtrl.$inject = [
  '$scope'
  '$filter'
  '$translate'
  '$location'
  'flash'
  'RegistrationService'
  'AuthService'
  'TermService'
]

module.exports = RegistrationEmailSuccessCtrl



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/registration/email-success-controller.coffee